module.exports = __webpack_public_path__ + "img/zhibo_share.06502201.png";